import { useCallback } from 'react'
import { runSendMessage } from './runSendMessage'

/** @param {object} m */
export function useSendMessageAction(m) {
  const handleSendMessage = useCallback((payload) => runSendMessage(m, payload), [m])
  return { handleSendMessage }
}
